import React, { useState, useEffect } from 'react';
import SelecionarCategoria from '../Utils/SelecionarCategoria';
import SelecionarMarca from '../Utils/SelecionarMarca';
import ImageCropper from '../Utils/ImageCropper';
import { Form, Button, Card, Alert, Col, Row, InputGroup, Tab, Nav, Container} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';
import ReactMarkdown from 'react-markdown';
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const Produto = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formType, setFormType] = useState('novo');
    const {
      setTitle,
    } = useProvider();
    
    setTitle("Produto");
    
    useEffect(()=>{
      if(id && formType==='novo'){
        setFormType('inicio');
      }
    },[id])
    
    return (<>
      <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
        <Nav variant="tabs" className="justify-content-center">
          {id && (<>
            <Nav.Item>
              <Nav.Link eventKey="inicio">Início</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="editar">Editar</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="estoque">Estoque</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="vendas">Vendas</Nav.Link>
            </Nav.Item>
          </>)}
        </Nav>

        <Tab.Content>
          {formType === 'novo' && <ProdutoForm />}
          {formType === 'inicio' && <InicioProduto />}
          {formType === 'editar' && <ProdutoForm />}
          {formType === 'estoque' && <EstoqueProdutoForm />}
          {formType === 'vendas' && <VendasProdutoForm />}
        </Tab.Content>
      </Tab.Container>
    </>)
};


const ProdutoForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [produto, setProduto] = useState();
    const [marcaId, setMarcaId] = useState();
    const [fileFoto, setFileFoto] = useState();
    const [categoriaId, setCategoriaId] = useState();
    const [formErrors, setFormErrors] = useState({});
    const {
      crud,
      setLinks, 
      setBtns,
      buscarDadosPorId,
      salvarDados,
      setTitulo,
    } = useProvider();
    const { post, patch, get, loading } = crud || {};
    const formData = new FormData();
  

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([{ icon: 'bi-check-lg', onClick: handleSubmit }]);
        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, produto, marcaId, categoriaId, fileFoto]); // Removidas dependências desnecessárias

    // Carrega o produto ao editar
    useEffect(() => {
      if (id) {
        carregarProdutoLocal();
      }
    }, [id]);

    const carregarProdutoLocal = async () => {
        try {
            const response = await buscarDadosPorId("db_produtos", parseInt(id));
            if (response) {
                const item = response;
                setProduto(item);
                setCategoriaId(item?.categoria);
                setMarcaId(item?.marca);
            }
        } catch (err) {
            validarErrosApi(err);
        }finally{
          carregarProduto();
        }
    };
    const carregarProduto = async () => {
        try {
            const response = await get(`/gvendas/produtos/${id}/`);
            if (response && response.length) {
                const item = response[0];
                setProduto(item);
                setCategoriaId(item?.categoria);
                setMarcaId(item?.marca);
                await salvarDados("db_produtos", response[0]);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        //alert(JSON.stringify(err))
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar o produto.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            ...err?.response?.data,
            quantidade_em_estoque: err.response?.data?.quantidade_em_estoque,
            nome_do_produto: err.response?.data?.nome_do_produto,
        }));
    };

    const handleSubmit = async (e) => {
        if(e) e.preventDefault();
        
        const errors = {};
        if (produto?.nome_do_produto === '' || !produto?.nome_do_produto) errors.nome_do_produto = 'Por favor, informe o nome do produto.';
        if (parseFloat(produto?.preco_unitario || 0) <= 0) errors.preco_unitario = 'Por favor, informe o preço do produto.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});
        
        formData.append('ncm', produto?.ncm ||``);
        formData.append('codigo', produto?.codigo ||``);
        formData.append('nome_do_produto', produto?.nome_do_produto||``);
        formData.append('preco_unitario', parseFloat(produto?.preco_unitario||0).toFixed(2));
        formData.append('preco_custo', parseFloat(produto?.preco_custo||0).toFixed(2));
        formData.append('descricao', produto?.descricao||``);
        formData.append('marca', marcaId || ``);
        if(!id) formData.append('is_ativo', true);
        formData.append('categoria', categoriaId || ``);
        if (fileFoto) formData.append('foto_do_produto', fileFoto);
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(formData, `/gvendas/produtos/${id || ''}${id ? '/' : ''}?filtros=id,nome_do_produto,foto_do_produto`, 'multipart/form-data');
            if (response && response.length) {
                Toast.fire({
                    icon: "success",
                    title: `Produto salvo com sucesso`
                });
                //alert(response[0].foto_do_produto)
                if(id){
                  navigate(-1);
                  return
                }
                navigate(`/produtos/${response[0].id}?tipo=editar`, {replace:true});
            }
        } catch (err) {
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            Toast.fire({
              icon: 'error',
              title: `Sem conexão`
            });
          }else{
            //alert(JSON.stringify(err.response))
            validarErrosApi(err);
          }
        }
    };
    

    return (
        <div className="">
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <ImageCropper id={id} foto={produto?.foto_do_produto} setFoto={setFileFoto} />
                        
                        <Form.Group controlId="formCodigo">
                            <InputGroup>
                              <span className="input-group-text">Cód</span>
                              <Form.Control 
                                  type="text" 
                                  value={produto?.codigo || ``} 
                                  onChange={(e) => setProduto((prevItem) => ({
                                    ...prevItem,
                                    codigo: e.target.value
                                  }))}
                              />
                              <span className="input-group-text">NCM</span>
                              <Form.Control 
                                  type="text" 
                                  value={produto?.ncm || ``} 
                                  onChange={(e) => setProduto((prevItem) => ({
                                    ...prevItem,
                                    ncm: e.target.value
                                  }))}
                              />
                            </InputGroup>
                            {formErrors.codigo && <Alert variant="danger">{formErrors.codigo}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formNome">
                            <Form.Label>Nome do Produto *</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={produto?.nome_do_produto} 
                                onChange={(e) => setProduto((prevItem) => ({
                                    ...prevItem,
                                    nome_do_produto: e.target.value
                                }))}
                            />
                            {formErrors.nome_do_produto && <Alert variant="danger">{formErrors.nome_do_produto}</Alert>}
                        </Form.Group>
                        <Row>
                          <Col>
                            <Form.Group controlId="formPreco" className="mt-3">
                                <Form.Label>Preço de venda *</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={produto?.preco_unitario} 
                                    onChange={(e) => setProduto((prevItem) => ({
                                        ...prevItem,
                                        preco_unitario: e.target.value
                                    }))}
                                    onBlur={(e) => setProduto((prevItem) => ({
                                        ...prevItem,
                                        preco_unitario: parseFloat(e.target.value||0).toFixed(2),
                                        preco_custo:prevItem?.preco_custo||(parseFloat(e.target.value||0)/2).toFixed(2)
                                    }))}
                                />
                                {formErrors.preco_unitario && <Alert variant="danger">{formErrors.preco_unitario}</Alert>}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group controlId="formPrecoCusto" className="mt-3">
                                <Form.Label>Preço de custo</Form.Label>
                                <InputGroup>
                                  <Form.Control
                                      type="number"
                                      step="0.01"
                                      value={produto?.preco_custo} 
                                      onChange={(e) => setProduto((prevItem) => ({
                                          ...prevItem,
                                          preco_custo: e.target.value
                                      }))}
                                      onBlur={(e) => setProduto((prevItem) => ({
                                          ...prevItem,
                                          preco_custo: parseFloat(e.target.value||0).toFixed(2)
                                      }))}
                                  />
                                  <Button onClick={()=>setProduto((prevItem)=>({
                                    ...prevItem,
                                    preco_custo:(parseFloat(prevItem?.preco_unitario||0)/2).toFixed(2)
                                  }))} variant="secondary">÷</Button>
                                </InputGroup>
                                {formErrors.preco_custo && <Alert variant="danger">{formErrors.preco_custo}</Alert>}
                            </Form.Group>
                          </Col>
                        </Row>
                        <SelecionarMarca label="Marca" marcaId={marcaId} setMarcaId={setMarcaId} />
                        {formErrors.marcaId && <Alert variant="danger">{formErrors.marcaId}</Alert>}

                        <SelecionarCategoria defaultText={` `} tipo={`produtos`} categoriaId={categoriaId} setCategoriaId={setCategoriaId} label="Categoria"/>
                      
                        {formErrors.categoriaId && <Alert variant="danger">{formErrors.categoriaId}</Alert>}
                        
                        <Form.Group controlId="formDescricao" className="mt-3">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                value={produto?.descricao} 
                                onChange={(e) => setProduto((prevItem) => ({
                                    ...prevItem,
                                    descricao: e.target.value
                                }))}
                                rows={5} 
                            />
                        </Form.Group>


                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {id ? 'Salvar Alterações' : 'Cadastrar Produto'}
                        </Button>
                    </Form>
        </div>
    );
};
const InicioProduto = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [produto, setProduto]=useState();
    const [formErrors, setFormErrors] = useState({});
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDadosPorId,
      salvarDados,
    } = useProvider();
    const { post, patch, get, loading } = crud || {};
    const formData = new FormData();

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
          //{ icon: 'bi-check-lg', onClick: ()=>{alert(JSON.stringify(produto))} },
        ]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks]); // Removidas dependências desnecessárias

    // Carrega o produto ao editar
    useEffect(() => {
        if (id) {
            carregarProdutoLocal();
        }
    }, [id]);
    
    const carregarProdutoLocal = async () => {
        try {
            const response = await buscarDadosPorId("db_produtos",parseInt(id));
            if (response) {
                setProduto(response);
            }
        } catch (err) {
            validarErrosApi(err);
        }finally{
          carregarProduto();
        }
    };
    const carregarProduto = async () => {
        try {
            const response = await get(`/gvendas/produtos/${id}/`);
            if (response && response.length) {
                setProduto(response[0]);
                await salvarDados("db_produtos", response[0]);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar o produto.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            ...err.response?.data,
            apiError: errorMessage,
        }));
    };


    return (
      <>
        <div className="">
          <ImageCropper foto={produto?.foto_do_produto} so_exibe={true} />
    
          {produto?.variacao < 0 && (
            <div className="text-muted">
              {produto?.variacao}%
            </div>
          )}
    
          <div className="fs-6">{produto?.nome_do_produto}</div>
    
          <div className="fs-5">
            {produto?.variacao < 0 && (
              <s className="small text-muted">
                {parseFloat(produto?.preco_unitario || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </s>
            )}{' '}
            {parseFloat(produto?.preco_de_venda || 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
    
          <Row>
            <Col xs={12} sm={12}>
              <ReactMarkdown>{produto?.descricao}</ReactMarkdown>
            </Col>
            <Col xs={12} sm={4}>
              {produto?.data_ultima_venda && (<>
                {`Última venda: ${dayjs(produto.data_ultima_venda).format("DD/MM/YYYY")}`}
              </>)}
            </Col>
            <Col xs={6} sm={4}>
              {produto?.preco_custo && (<>
                {`Custo: ${parseFloat(produto?.preco_custo || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}`}
              </>)}
            </Col>
            <Col xs={6} sm={4}>
              {parseFloat(produto?.preco_lucro||0)>=0 && (<>
                {`Lucro: ${parseFloat(produto?.preco_lucro || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}`}
              </>)}
            </Col>
            <Col xs={6} sm={4}>
              {`Variação: ${parseFloat(produto?.variacao||0).toFixed(2)}%`}
            </Col>
            <Col xs={6} sm={4}>
              {parseInt(produto?.quantidade_vendidos||0)>=0 && (<>
                {`Total vendido: ${produto?.quantidade_vendidos||0}`}
              </>)}
            </Col>
            <Col xs={6} sm={4}>
              {parseInt(produto?.quantidade_em_estoque||0) >= 0 && (<>
                {`Estoque: ${produto?.quantidade_em_estoque||0}`}
              </>)}
            </Col>
            <Col xs={6} sm={4}>
              {parseFloat(produto?.preco_total_em_estoque||0)>=0 && (<>
                {`Total: ${parseFloat(produto?.preco_total_em_estoque || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}`}
              </>)}
            </Col>
          </Row>
        </div>
      </>
    );
};
const EstoqueProdutoForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [produto, setProduto]=useState();
    const [formErrors, setFormErrors] = useState({});
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDadosPorId,
      salvarDados,
    } = useProvider();
    const { post, patch, get, loading } = crud || {};
    const formData = new FormData();
    


    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([{ icon: 'bi-check-lg', onClick: handleSubmit }]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, produto]); // Removidas dependências desnecessárias

    // Carrega o produto ao editar
    useEffect(() => {
        if (id) {
            carregarProdutoLocal();
        }
    }, [id]);
    
    useEffect(()=>{
      if(!produto?.is_ativo){
        setProduto((prevItem)=>({
          ...prevItem,
          controlar_estoque:false,
          data_fim_promocao:"",
          preco_promocional:"",
          is_promocao:false,
          quantidade_em_estoque:0,
          quantidade_minima_em_estoque:0,
          is_compartilhar:false,
          is_catalogo:false,
        }));
      }
    },[produto?.is_ativo])

    const carregarProdutoLocal = async () => {
        try {
            const response = await buscarDadosPorId("db_produtos",parseInt(id));
            if (response) {
                setProduto(response);
            }
        } catch (err) {
            validarErrosApi(err);
        }finally{
          carregarProduto();
        }
    };
    const carregarProduto = async () => {
        try {
            const response = await get(`/gvendas/produtos/${id}/`);
            if (response && response.length) {
                setProduto(response[0]);
                await salvarDados("db_produtos", response[0]);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar o produto.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            quantidade_em_estoque: err.response?.data?.quantidade_em_estoque,
        }));
    };

    const handleSubmit = async (e) => {
        if(e) e.preventDefault();
        
        const errors = {};
        // if (nome === '' || !nome) errors.nome_do_produto = 'Por favor, informe o nome do produto.';
        // if (preco === '' || !preco) errors.preco = 'Por favor, informe o preço do produto.';
        if (produto?.is_promocao && parseFloat(produto?.preco_promocional || 0) <= 0) errors.preco_promocional = 'Por favor, informe o preço em promoção do produto.';
        //if (quantidade === '') errors.quantidade = 'Por favor, informe a quantidade em estoque.';
        //if (!marcaId) errors.marcaId = 'Por favor, selecione a marca do produto.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});
        
        formData.append('is_ativo', produto?.is_ativo||false);
        
        formData.append('is_promocao', produto?.is_promocao || false);
        formData.append('preco_promocional', produto?.preco_promocional? parseFloat(produto?.preco_promocional||0).toFixed(2) : "");
        formData.append('data_fim_promocao', produto?.data_fim_promocao || "");
        
        formData.append('is_compartilhar', produto?.is_compartilhar||false);
        formData.append('is_catalogo', produto?.is_catalogo||false);
        
        formData.append('controlar_estoque', produto?.controlar_estoque||false);
        formData.append('quantidade_em_estoque', parseInt(produto?.quantidade_em_estoque || 0));
        formData.append('quantidade_minima_em_estoque', parseInt(produto?.quantidade_minima_em_estoque || 0));
        
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(formData, `/gvendas/produtos/${id || ''}${id ? '/' : ''}?filtros=nome_do_produto`, 'multipart/form-data');
            if (response && response.length) {
                Toast.fire({
                    icon: "success",
                    title: `Produto salvo com sucesso`
                });
                navigate(-1);
            }
        } catch (err) {
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            Toast.fire({
              icon: 'error',
              title: `Sem conexão`
            });
          }else{
            validarErrosApi(err);
          }
        }
    };
    

    return (
      <div className="">
        <Form onSubmit={handleSubmit}>
          {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
    
          <ImageCropper foto={produto?.foto_do_produto} so_exibe={true}  />
    
          {produto?.variacao < 0 && (
            <div className="text-muted">
              {produto?.variacao}%
            </div>
          )}
    
          <div className="fs-6">{produto?.nome_do_produto}</div>
    
          <div className="fs-5">
            {produto?.variacao < 0 && (
              <s className="small text-muted">
                {parseFloat(produto?.preco_unitario || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </s>
            )}{' '}
            {parseFloat(produto?.preco_de_venda || 0).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </div>
    
          <Form.Group controlId="formIsAtivo" className="mt-3">
            <Form.Check 
              type="switch" 
              label="Ativo"
              checked={produto?.is_ativo}
              onChange={(e) =>
                setProduto((prevItem) => ({
                  ...prevItem,
                  is_ativo: e.target.checked,
                }))
              }
            />
          </Form.Group>
    
          {produto?.is_ativo && (
            <>
              <Form.Group controlId="formControlarEstoque" className="mt-3">
                <Form.Check 
                  type="switch" 
                  label="Controlar Estoque"
                  checked={produto?.controlar_estoque}
                  onChange={(e) =>
                    setProduto((prevItem) => ({
                      ...prevItem,
                      controlar_estoque: e.target.checked,
                    }))
                  }
                />
              </Form.Group>
              {produto?.controlar_estoque && (
                <>
                  <Row>
                    <Col xs={6}>
                      <Form.Group controlId="formQuantidadeEmEatoque">
                        <Form.Label>Quantidade</Form.Label>
                        <InputGroup>
                          <Button
                            onClick={() =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_em_estoque:
                                  parseInt(prevItem.quantidade_em_estoque || 0) > 0
                                    ? parseInt(prevItem.quantidade_em_estoque || 0) - 1
                                    : 0,
                              }))
                            }
                            variant="secondary"
                          >
                            -
                          </Button>
                          <Form.Control
                            type="text"
                            value={produto?.quantidade_em_estoque}
                            onChange={(e) =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_em_estoque: e.target.value,
                              }))
                            }
                          />
                          <Button
                            onClick={() =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_em_estoque: parseInt(prevItem.quantidade_em_estoque || 0) + 1,
                              }))
                            }
                            variant="secondary"
                          >
                            +
                          </Button>
                        </InputGroup>
                        {formErrors.quantidade_em_estoque && (
                          <Alert variant="danger">{formErrors.quantidade_em_estoque}</Alert>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={6}>
                      <Form.Group controlId="formQuantidadeMinimaEmEstoque">
                        <Form.Label>Mínimo</Form.Label>
                        <InputGroup>
                          <Button
                            onClick={() =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_minima_em_estoque:
                                  parseInt(prevItem.quantidade_minima_em_estoque || 0) > 0
                                    ? parseInt(prevItem.quantidade_minima_em_estoque || 0) - 1
                                    : 0,
                              }))
                            }
                            variant="secondary"
                          >
                            -
                          </Button>
                          <Form.Control
                            type="text"
                            value={produto?.quantidade_minima_em_estoque}
                            onChange={(e) =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_minima_em_estoque: e.target.value,
                              }))
                            }
                          />
                          <Button
                            onClick={() =>
                              setProduto((prevItem) => ({
                                ...prevItem,
                                quantidade_minima_em_estoque:
                                  parseInt(prevItem.quantidade_minima_em_estoque || 0) + 1,
                              }))
                            }
                            variant="secondary"
                          >
                            +
                          </Button>
                        </InputGroup>
                        {formErrors.quantidade_minima_em_estoque && (
                          <Alert variant="danger">{formErrors.quantidade_minima_em_estoque}</Alert>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
    
                </>
              )}
    
              <Form.Group controlId="formPromocional" className="mt-3">
                <Form.Check 
                  type="switch" 
                  label="Na promoção"
                  checked={produto?.is_promocao}
                  onChange={(e) =>
                    setProduto((prevItem) => ({
                      ...prevItem,
                      is_promocao: e.target.checked,
                    }))
                  }
                />
              </Form.Group>
    
              {produto?.is_promocao && (
                <>
                  <Row>
                    <Col xs={6}>
                      <Form.Group controlId="formPrecoPromocional" className="mt-3">
                        <Form.Label>Preço*</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          value={produto.preco_promocional}
                          onChange={(e) =>
                            setProduto((prevItem) => ({
                              ...prevItem,
                              preco_promocional: e.target.value,
                            }))
                          }
                          onBlur={(e) =>
                            setProduto((prevItem) => ({
                              ...prevItem,
                              preco_promocional: parseFloat(e.target.value || 0).toFixed(2),
                            }))
                          }
                        />
                        {formErrors.preco_promocional && (
                          <Alert variant="danger">{formErrors.preco_promocional}</Alert>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={6}>
                      <Form.Group controlId="formFimPromocao" className="mt-3">
                        <Form.Label>Fim da Promoção</Form.Label>
                        <Form.Control
                          type="date"
                          value={produto?.data_fim_promocao}
                          onChange={(e) =>
                            setProduto((prevItem) => ({
                              ...prevItem,
                              data_fim_promocao: e.target.value,
                            }))
                          }
                        />
                        {formErrors.data_fim_promocao && (
                          <Alert variant="danger">{formErrors.data_fim_promocao}</Alert>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
    
              <Form.Group controlId="formCompartilhar" className="mt-3">
                <Form.Check 
                  type="switch" 
                  label="Status Público"
                  checked={produto?.is_compartilhar}
                  onChange={(e) =>
                    setProduto((prevItem) => ({
                      ...prevItem,
                      is_compartilhar: e.target.checked,
                    }))
                  }
                />
              </Form.Group>
              
              <Form.Group controlId="formCatalogo" className="mt-3">
                <Form.Check 
                  type="switch" 
                  label="Catálogo"
                  checked={produto?.is_catalogo}
                  onChange={(e) =>
                    setProduto((prevItem) => ({
                      ...prevItem,
                      is_catalogo: e.target.checked,
                    }))
                  }
                />
              </Form.Group>
    
            </>
          )}
    
          <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
            {loading ? 'Salvando...' : id ? 'Salvar Alterações' : 'Cadastrar Produto'}
          </Button>
        </Form>
      </div>
    );
};
const VendasProdutoForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formErrors, setFormErrors] = useState({});
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDadosPorId,
      salvarDados,
    } = useProvider();
    const { post, patch, get, loading } = crud || {};
    const formData = new FormData();
    

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
          //{ icon: 'bi-check-lg', onClick: handleSubmit },
        ]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks]); // Removidas dependências desnecessárias

    // Carrega o produto ao editar
    useEffect(() => {
        if (id) {
            carregarVendas();
        }
    }, [id]);
    


    const carregarVendas = async () => {
        try {
            const response = await get(`/gvendas/vendas/?venda_itensvenda__produto__in=${id || 0}/`);
            if (response && response.length) {

            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar o produto.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
        }));
    };



    return (
        <div className="">
        </div>
    );
};


export default Produto;